import React, { useContext, useEffect, useState } from 'react';
import { AdminContext } from '../../context/AdminContext';
import AppIcons from '../../icons';
import styles from './styles.module.css';

const HiddenAudioPlayer = ({
  id,
  src,
  onClick,
  setActiveMessage,
  activeMessage,
  control,
  item,
}) => {
  // let audio;
  // let progress;
  let play = false;
  // const [playing, setPlaying] = useState(false);
  const {
    activeAudio,
    setActiveAudio,
    playing,
    seekValue,
    setSeekValue,
    setPlaying,
    direction,
  } = useContext(AdminContext);

  console.log('activeAudio', activeAudio);
  useEffect(() => {
    const hiddenAudio = document.getElementById('hiddenAudio');
    if (playing) {
      hiddenAudio.play();
    } else {
      hiddenAudio.pause();
    }
    // hiddenAudio.pause();
  }, [playing]);
  const playFunction = () => {
    // document.getElementById(`this${activeAudio?.id}`).play();
    // console.log('audio====', document.getElementById(`this${activeAudio?.id}`));
    setPlaying(true);
    // let audio = document.getElementById(`this${id}`);
    // // let progress = document.getElementById(`progress${id}`);
    // console.log('idd', id);
    // if (activeMessage != id) {
    //   setActiveMessage(id);
    // } else {
    //   if (audio) {
    //     audio.play();
    //     play = true;
    //     setPlaying(true);
    //   }
    // }
    // const hiddenAudio = document.getElementById('hiddenAudio');

    // hiddenAudio.play();
  };
  useEffect(() => {
    setSeekValue(0);
  }, []);
  // useEffect(() => {
  //   const hiddenAudio = document.getElementById('hiddenAudio');
  //   if (playing) {
  //     hiddenAudio.play();
  //   } else {
  //     hiddenAudio.pause();
  //   }
  //   // hiddenAudio.pause();
  // }, [playing]);
  // useEffect(() => {
  //   if (seekValue != 0) {
  //     const hiddenAudio = document.getElementById('hiddenAudio');
  //     hiddenAudio.currentTime = (seekValue * hiddenAudio.duration) / 100;
  //   }
  // }, [seekValue]);
  const pauseFunction = () => {
    // document.getElementById(`this${activeAudio?.id}`).pause();
    setPlaying(false);

    // const hiddenAudio = document.getElementById('hiddenAudio');

    // hiddenAudio.pause();

    // let audio = document.getElementById(`this${id}`);
    // let progress = document.getElementById(`progress${id}`);
    // console.log('playing==', audio.playing, audio);
    // audio.pause();
    // play = false;
    // setPlaying(false);
  };
  const onTimeUpdateFunction = () => {
    let actual = document.getElementById(`this${activeAudio?.id}`);
    let actualseek = document.getElementById(`progress${activeAudio?.id}`);

    let audio = document.getElementById(`${id}`);
    let progress = document.getElementById(`hiddenAudioSeekbar`);
    if (progress && audio) {
      progress.value = (audio.currentTime / audio.duration) * 100;
      setSeekValue(progress.value);
      // actualseek.value = progress.value;
      // actualseek.value = (audio.currentTime / audio.duration) * 100;
    }
  };
  const changeProggress = () => {
    let actual = document.getElementById(`this${activeAudio?.id}`);
    let actualseek = document.getElementById(`progress${activeAudio?.id}`);

    let audio = document.getElementById(`${id}`);
    let progress = document.getElementById(`hiddenAudioSeekbar`);
    if (audio.duration && progress && audio) {
      audio.currentTime = (progress.value * audio.duration) / 100;
      // actual.currentTime = (progress.value * audio.duration) / 100;
      // setSeekValue((progress.value * audio.duration) / 100);
    } else {
      false;
    }
  };
  // console.log('playingseek', seekValue);
  return (
    <>
      <div
        className={`${styles.player} cursor-default ${'mr-auto'}`}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <audio
          id={`${id}`}
          src={src}
          onTimeUpdate={() => {
            onTimeUpdateFunction();
          }}
          className={`e-rangeHidden`}
        ></audio>

        <div className={styles.controls}>
          <div className={styles.play}>
            {!playing ? (
              <AppIcons.PlayIcon
                width={15}
                height={15}
                onClick={() => playFunction()}
                className={`${styles.icon} noFilterSvg ${
                  !playing && 'fillUnactive'
                }`}
              />
            ) : (
              <AppIcons.PauseIcon
                width={15}
                height={15}
                onClick={() => pauseFunction()}
                className={`${styles.icon} noFilterSvg ${
                  playing && 'fillUnactive'
                }`}
              />
            )}
          </div>

          <input
            id={`hiddenAudioSeekbar`}
            type="range"
            onChange={() => changeProggress()}
            className={`e-rangeHidden ${styles.hiddenSeekbar}`}
            defaultValue={seekValue}
            // value={0}
          />
        </div>
      </div>
    </>
  );
};

export default HiddenAudioPlayer;
